import apiConfig from "@/configs/api-config";
import apiUtil from "@/utils/api-util";

// 列表
var list = (params, successCallback, failCallback) => {
    apiUtil.config(apiConfig.banner.list).request({
        params: params
    }).then(result => {
        if(result.error_code == apiConfig.errorCode.success) {
            successCallback(result.data);
        } else {
            failCallback(result.error_code, result.errorMsg);
        }
    });
}
export default {
    list
}



// WEBPACK FOOTER //
// ./src/models/banner-model.js